import styles from "./index.module.less";
import { Iconsvg, ButtonField } from "@wk/components-react16";
import { useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { Modal } from "antd";
import Icon from "@/components/Icon";
import xjc from "@/assets/img/xjc.png";
import management from "@/assets/img/management.png";
import clinic from "@/assets/img/clinic.png";
import research from "@/assets/img/research.png";
import teaching from "@/assets/img/teaching.png";
import resource1 from "@/assets/img/resource1.png";
import resource2 from "@/assets/img/resource2.png";
import resource3 from "@/assets/img/resource3.png";
import resource4 from "@/assets/img/resource4.png";
import liangdian1 from "@/assets/img/index/liangdian_1.png";
import liangdian2 from "@/assets/img/index/liangdian_2.png";
import liangdian3 from "@/assets/img/index/liangdian_3.png";
import liangdian4 from "@/assets/img/index/liangdian_4.png";
import richeng1 from "@/assets/img/index/richeng_1.png";
import richeng2 from "@/assets/img/index/richeng_2.png";
import richeng3 from "@/assets/img/index/richeng_3.png";
import richeng4 from "@/assets/img/index/richeng_4.png";
import richeng5 from "@/assets/img/index/richeng_5.png";
import richeng6 from "@/assets/img/index/richeng_6.png";
import richeng7 from "@/assets/img/index/richeng_7.png";
import { useUser } from "@/utils/UserContext";

// import { getJudgeList } from "../../services/judge";
// import { getCaseList } from "@/services/history";

const Home = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const [userInfo, setUserInfo] = useState();
  const [modal, modalContextHolder] = Modal.useModal();

  const highlightsRef = useRef(null);
  const categoriesRef = useRef(null);
  const timelineRef = useRef(null);
  const faqRef = useRef(null);
  const pastCasesRef = useRef(null);

  const navMenuList = [
    { name: "本届亮点", section: "highlights", ref: highlightsRef },
    { name: "大赛分类及评分标准", section: "categories", ref: categoriesRef },
    { name: "大赛赛程", section: "timeline", ref: timelineRef },
    { name: "FAQ常见问题", section: "faq", ref: faqRef },
    { name: "更多资源", section: "pastCases", ref: pastCasesRef },
  ];

  const highlightList = [
    {
      title: "大赛奖项",
      content: [
        "卓越案例奖",
        "优秀案例奖",
        "优秀机构组织奖"
      ],
      icon: liangdian1,
    },
    {
      title: "中国临床案例成果数据库直接收录",
      content: [
        "临床和住培案例“卓越案例奖”直接被中国临床案例成果数据库直接收录，中华医学会颁发收录证书"
      ],
      icon: liangdian2,
    },
    {
      title: "决赛环节",
      content: [
        "初赛PPT或PDF投稿",
        "决赛临床和住培案例按照中国临床案例成果数据库标准 采用Word投稿"
      ],
      icon: liangdian3,
    },
    {
      title: "决赛赛前训练营",
      content: [
        "威科医学联合中华医学会杂志社，为决赛临床与住培选手进行案例撰写培训"
      ],
      icon: liangdian4,
    },
  ];

  // Track active nav item
  const [activeNav, setActiveNav] = useState("highlights");

  // Scroll to section function
  const scrollToSection = (ref, section) => {
    // setActiveNav(section);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    // 使用节流函数优化滚动处理
    const throttle = (func, delay) => {
      let lastCall = 0;
      return (...args) => {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
          return;
        }
        lastCall = now;
        return func(...args);
      };
    };

    const handleScroll = () => {
      // 检测当前哪个部分在视口中最突出
      const scrollPosition = window.scrollY + 250; // 添加偏移量，使导航项更早激活

      // 遍历所有部分，查找当前滚动位置中最突出的部分
      let currentSection = "highlights"; // 默认为第一个部分

      // 从后往前检查，这样可以正确处理重叠的部分
      for (let i = navMenuList.length - 1; i >= 0; i--) {
        const { section, ref } = navMenuList[i];
        if (ref.current && ref.current.offsetTop <= scrollPosition) {
          currentSection = section;
          break;
        }
      }

      // 如果找到了不同的部分，更新activeNav状态
      if (currentSection !== activeNav) {
        setActiveNav(currentSection);
      }
    };

    // 使用节流函数包装滚动处理函数，限制为每100ms最多执行一次
    const throttledHandleScroll = throttle(handleScroll, 100);

    // 添加滚动事件监听器
    window.addEventListener("scroll", throttledHandleScroll);

    // 初始化检查当前部分
    handleScroll();

    // 清理函数：移除滚动事件监听器
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
    };
  }, [activeNav, navMenuList]); // 依赖项

  const [expandedCaseKey, setExpandedCaseKey] = useState("clinic");

  const expandedCaseList = [
    {
      title: "临床案例",
      key: "clinic",
      headList: ["指标名称", "权重", "指标内容"],
      tableList: [
        {
          first: "案例完整度及科学性",
          second: "66",
          list: [
            "真实且全面的患者基本情况及相关病史",
            "完善的体格检查、实验室检查及影像学检查（含【图片】并有重点总结）",
            "完整且合理的诊断、鉴别诊断",
            "患者最终的诊断结果、选择的治疗方式、结局转归（随访预后等），需要结合UpToDate等相关循证资源展示治疗方法或选择药物的正确科学、规范性",
            "临床诊疗过程全面、清晰、严谨且逻辑性强，对案例有充分的思考回顾（以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述）",
            "查阅UpToDate等相关循证资源，充分了解该疾病当前最佳的诊疗策略及学术研究进展",
          ],
        },
        {
          first: "案例实际价值",
          second: "22",
          list: [
            "选择案例为疑难、罕见病、多学科疾病、易误诊疾病和复杂疾病",
            "经过循证检索之后，诊断和/或治疗疾病的方法有进一步的创新或优化，在专业领域有推广价值或对临床诊治有范例作用",
            "从临床实际问题中获得科研启发，或该案例有进一步研究的价值，并且有后续跟进",
          ],
        },
        {
          first: " 案例规范及美观性",
          second: "12",
          list: [
            "PPT制作美观，有视觉效果",
            "图片清晰典型，表格及流程图规范精炼",
          ],
        },
        {
          first: "特殊加分",
          second: "20",
          list: [
            "有完整的应用临床循证数据库解决案例涉及问题(诊疗决策/辅助教学)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
          ],
        },
      ],
      img: clinic,
    },

    {
      title: "住培案例",
      key: "residence",
      headList: ["指标名称", "权重", "指标内容"],
      tableList: [
        {
          first: "案例完整度及科学性",
          second: "66",
          list: [
            "真实且全面的患者基本情况及相关病史",
            "完善的体格检查、实验室检查及影像学检查（含【图片】并有重点总结）",
            "完整且合理的诊断、鉴别诊断",
            "患者最终的诊断结果、选择的治疗方式、结局转归（随访预后等），需要结合UpToDate等相关循证资源展示治疗方法或选择药物的正确科学、规范性",
            "临床诊疗过程全面、清晰、严谨且逻辑性强，对案例有充分的思考回顾（以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述）",
            "查阅UpToDate等相关循证资源，充分了解该疾病当前最佳的诊疗策略及学术研究进展",
          ],
        },
        {
          first: "案例实际价值",
          second: "22",
          list: [
            "选择案例为疑难、罕见病、多学科疾病、易误诊疾病和复杂疾病",
            "经过循证检索之后，诊断和/或治疗疾病的方法有进一步的创新或优化，在专业领域有推广价值或对临床诊治有范例作用",
            "从临床实际问题中获得科研启发，或该案例有进一步研究的价值，并且有后续跟进",
          ],
        },
        {
          first: "案例规范及美观性",
          second: "12",
          list: [
            "PPT制作美观，有视觉效果",
            "图片清晰典型，表格及流程图规范精炼",
          ],
        },
        {
          first: "特殊加分",
          second: "20",
          list: [
            "有完整的应用临床循证数据库解决案例涉及问题(诊疗决策/辅助教学)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
          ],
        },
      ],
      img: clinic,
    },

    {
      title: "教学案例",
      key: "teaching",
      headList: ["评分项", "权重", "评分内容"],
      tableList: [
        {
          first: "案例内容",
          second: "60",
          list: [
            "与教学有关的患者情况（病史、检查结果、诊疗方式等），展示教学过程并总结，应有教学模式的亮点总结，教学结果的展示或预判",
            "案例选择有带教价值，教学模式有创新（包括基于如床边教学、以问题为导向的教学、以病例为基础的教学等场景模式下的真实教学案例，或其他创新教学模式）",
            "有完整的应用临床循证数据库解决案例涉及问题(辅助教学)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
            "对案例有充分的思考回顾：以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述",
            "PPT制作是否美观，有视觉效果",
          ],
        },
        {
          first: "思维过程",
          second: "30",
          list: [
            "教学过程是否全面、清晰、严谨且逻辑性强",
            "基于循证医学对检索结果的决策过程：对证据的思考分析和最佳证据的筛选过程；",
            "有对该案例在证据分析和筛选上的应用总结及反思",
          ],
        },
        {
          first: "与UpToDate结合度",
          second: "10",
          list: [
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
          ],
        },
      ],
      img: teaching,
    },

    {
      title: "科研案例",
      key: "research",
      headList: ["指标名称", "权重", "评分内容"],
      tableList: [
        {
          first: "案例内容",
          second: "60",
          list: [
            "与科研有关的患者情况（病史、检查结果、诊疗方式或临床情况总结等）科研课题内容完整性，包括课题详情、在研情况、结果预判（立项阶段的阐述亦可）",
            "所选课题是否国内外未见报道；或在类似研究上有新颖点促使该课题有新的发展、补充或修正；国外已有研究，但尚需结合我国实际进行探素，填补国内此领域的空白，对临床的意义等",
            "有完整的应用临床循证数据库解决案例涉及问题(助力科研创新)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
            "对案例有充分的思考回顾：以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述",
            "PPT制作是否美观，有视觉效果",
          ],
        },
        {
          first: "思维过程",
          second: "30",
          list: [
            "科研过程是否全面、清晰、严谨且逻辑性强",
            "基于循证医学对检索结果的决策过程：对证据的思考分析和最佳证据的筛选过程",
            "有对该案例在证据分析和筛选上的应用总结及反思",
          ],
        },
        {
          first: "与UpToDate组合度",
          second: "10",
          list: [
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
          ],
        },
      ],
      img: research,
    },

    {
      title: "管理案例",
      key: "management",
      headList: ["评分项", "权重", "评分内容"],
      tableList: [
        {
          first: "案例完整度及合理性",
          second: "50",
          list: [
            "解决医务、教学、住培或科研方面的统筹管理相关问题",
            "清晰描述案例背景，待解决问题，及其影响和意义；",
            "呈现管理过程：分析-计划-执行-跟进-反馈-效果等相关环节",
          ],
        },
        {
          first: "案例实际价值",
          second: "20",
          list: [
            "选择案例可体现与医院现有流程的差异，显著改善管理效果",
            "案例具有普遍和借鉴意义，管理方法有创新性",
            "如何解决计划或执行中遇到的问题",
          ],
        },
        {
          first: "循证医学价值",
          second: "20",
          list: [
            "体现利用相关循证资源解决管理问题的优势",
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容给予了支持。",
          ],
        },
        {
          first: "案例规范及美观性",
          second: "10",
          list: ["符合大赛案例规范；", "图片清晰典型，表格及流程图规范精炼"],
        },
      ],
      img: management,
    },
  ];

  const timelineList = [
    {
      title: "赛事启动",
      list: ["4月30日大赛启动", "机构赛同步启动"],
      icon: richeng1,
    },
    {
      title: "全国投稿",
      list: ["6月1日启动投稿", "10月11日截止投稿"],
      icon: richeng2,
    },
    {
      title: "初赛评审",
      list: ["11月17日公布决赛名单"],
      icon: richeng3,
    },
    {
      title: "决赛赛前训练营",
      list: ["11月下旬决赛选手赛前训练营", "12月20日决赛截止投稿"],
      icon: richeng4,
    },
    {
      title: "决赛评审启动",
      list: ["12月21日决赛评审启动"],
      icon: richeng5,
    },
    {
      title: "稿件返修",
      list: ["2027年2月4日进行审阅<br/>返修稿件，并给出终审意见"],
      icon: richeng6,
    },
    {
      title: "公布决赛结果",
      list: ["2027年3月下旬公布获奖名单"],
      icon: richeng7,
    },
  ];

  const [activeTab, setActiveTab] = useState("basic");

  const [faqDataKey, setFaqDataKey] = useState("");

  // FAQ data
  const faqData = {
    basic: [
      {
        question: "是否对参赛者的专业、学历、医院等级等有要求？",
        answer:
          "无要求，面向全国各级医疗机构的临床医生、医学生及相关医疗从业人员。",
      },
      {
        question: "是否允许团队参赛？团队成员人数和构成是否有规定？",
        answer:
          "允许团队参赛，团队成员人数不做限制。但奖励机制按照参赛作品数量对应，不对应人数。",
      },
      {
        question: "往届获奖者是否可以再次参赛？",
        answer:
          "允许往届获奖者参赛，但需提交新的案例，不能重复使用已获奖案例。",
      },
      {
        question:
          "案例类型是否有明确限制？例如，是否必须是疑难病例、罕见病例或具有教学意义的病例？",
        answer:
          "案例类型分为：临床、住培、教学、科研、管理。但疑难病例、罕见病例等具有创新性的病例更具有竞争优势。",
      },
      {
        question: "案例时间范围是否有要求？例如，是否必须是近期发生的病例？",
        answer: "要求案例为近1-2年内发生的病例，以确保案例的时效性和参考价值。",
      },
      {
        question: "是否可以使用已发表或已参加其他比赛的案例？",
        answer: "可以。",
      },
      {
        question: "案例中涉及的患者隐私信息如何处理？",
        answer: "案例必须隐去患者隐私信息（如姓名、身份证号等）。",
      },
      {
        question: "比赛分为几个阶段？每个阶段的具体时间和安排是怎样的？",
        answer:
          "比赛分为初赛和决赛。进入决赛后，主办方通过邮件或短信通知选手，并邀请参加决赛赛前训练营。具体时间参考官网中赛程安排。",
      },
      {
        question: "是否需要现场演讲？",
        answer:
          "不设置现场演讲。但获奖后，主办方将邀请获奖选手线上录制课程分享。",
      },
      {
        question: "比赛设有哪些奖项？每个奖项的获奖人数和奖励是什么？",
        answer:
          "比赛设置“优秀机构组织奖”、“卓越案例奖”、“优秀案例奖”，获奖总人数在30左右。奖励包含奖品、UpToDate使用权限。",
        table: {
          headList: ["奖项", "奖品"],
          tableList: [
            {
              first: "优秀机构组织奖",
              list: ["机构奖杯", "获奖证书"],
            },
            {
              first: "卓越案例奖",
              list: [
                "UpToDate临床顾问全平台账号1年使用权",
                "奖品（价值1000元）",
                "获奖证书",
              ],
            },
            {
              first: "优秀案例奖",
              list: [
                "UpToDate临床顾问移动端账号1年使用权",
                "奖品（价值800元）",
                "获奖证书",
              ],
            },
          ],
        },
      },
      {
        question: "问：获奖后UpToDate 账号使用权限如何分配？",
        answer: "每部获奖作品将获赠一个 UpToDate 账号，默认授予决赛时登记的作者。若团队获奖，经登记的第一作者同意，可转让给该作品登记的其他作者，但转让后不可变更且不可转予未参与案例创作的外部人员。",
      },
    ],

    details: [
      {
        question: "投稿是通过官方网站、邮箱还是其他平台？",
        answer: "目前仅支持官方网站投稿。",
      },
      {
        question: "投稿时需要提交哪些材料？例如，案例报告、PPT、视频等？",
        answer:
          "初赛投稿作品可接受PPT或PDF文件。如进入决赛，临床/住培案例需要按照中国临床案例成果数据库标准改写为完整的案例报告，采用Word或PDF文件投稿。",
      },
      {
        question: "投稿材料的格式和大小是否有要求？",
        answer: "PPT大小不超过100M。",
      },
      {
        question: "案例报告是否有固定模板？字数要求是多少？",
        answer: "案例无固定模板，不做字数要求",
      },
      {
        question:
          "案例报告需要包含哪些内容？例如，病史、检查、诊断、治疗、随访等？",
        answer: "病史、检查、诊断、治疗、随访及UpToDate的应用。详见评分标准。",
      },
      {
        question: "如何平衡案例报告的完整性和简洁性？",
        answer: "两者均占分值。详见评分标准。",
      },
      {
        question: "投稿后是否可以修改或撤回？",
        answer: "投稿后，选手本人无法修改或撤回。",
      },
      {
        question: "如何查询投稿状态和评审结果？",
        answer: "关注赛事官网及UpToDate公众号。",
      },
      {
        question: "比赛组委会的联系方式是什么？",
        answer: "health@wolterskluwer.cn",
      },
    ],

    help: [
      {
        question: "何种案例能够被中国临床案例成果数据库收纳？",
        answer:
          "获得“卓越案例奖”的临床及住培案例将被中国临床案例成果数据库直接收录。",
      },
      {
        question: "如果投稿至中国临床案例成果数据库，是否允许多位作者？",
        answer: "投稿案例允许多个作者，但第一作者和通信作者均只能有一位。",
      },
      {
        question:
          "如果未能获得“卓越案例奖”，我是否依然可以尝试投稿中国临床案例成果数据库？",
        answer: "可以，请您按照中国临床案例成果数据库要求自行投稿。",
      },
      {
        question:
          "如何获取收录证书？",
        answer: "稿件上线后，系统会自动将收录证书发送至通信作者的邮箱；您也可关注“中华病例说”小程序，在“案例库”页面找到“领取电子版收录证书”，认领文章后手动下载收录证书。",
      },
      {
        question:
          "收录证书中的作者顺序是否可以调整？",
        answer: "作者排序应在投稿前由全体作者共同讨论确定，投稿后不应再作改动。稿件一经上线，作者顺序将不予更改。",
      },
      {
        question:
          "对审稿修改意见存在异议，应如何反馈？",
        answer: "若您对修改意见有不同看法，请直接拨打中国临床案例成果数据库编辑部电话咨询：010-51322290、010-51322297、010-51322298、010-51322300。",
      },
      {
        question:
          "投稿后一般多久能收到审稿意见？",
        answer: "中国临床案例成果数据库的专家审稿期限为1个月，实际以审稿专家的审稿进度为准。",
      },
    ],

    // basic: [
    //   {
    //     category: "参赛资格",
    //     items: [
    //       {
    //         question: "是否对参赛者的专业、学历、医院等级等有要求？",
    //         answer:
    //           "无要求，面向全国各级医疗机构的临床医生、医学生及相关医疗从业人员。",
    //       },
    //       {
    //         question: "是否允许团队参赛？团队成员人数和构成是否有规定？",
    //         answer:
    //           "允许团队参赛，团队成员人数不做限制。但奖励机制按照参赛作品数量对应，不对应人数。",
    //       },
    //       {
    //         question: "往届获奖者是否可以再次参赛？",
    //         answer:
    //           "允许往届获奖者参赛，但需提交新的案例，不能重复使用已获奖案例。",
    //       },
    //     ],
    //   },
    //   {
    //     category: "案例要求",
    //     items: [
    //       {
    //         question:
    //           "案例类型是否有明确限制？例如，是否必须是疑难病例、罕见病例或具有教学意义的病例？",
    //         answer:
    //           "案例类型分为：临床、住培、教学、科研、管理。但疑难病例、罕见病例等具有创新性的病例更具有竞争优势。",
    //       },
    //       {
    //         question:
    //           "案例时间范围是否有要求？例如，是否必须是近期发生的病例？",
    //         answer:
    //           "要求案例为近1-2年内发生的病例，以确保案例的时效性和参考价值。",
    //       },
    //       {
    //         question: "是否可以使用已发表或已参加其他比赛的案例？",
    //         answer: "可以。",
    //       },
    //       {
    //         question: "案例中涉及的患者隐私信息如何处理？",
    //         answer: "案例必须隐去患者隐私信息（如姓名、身份证号等）。",
    //       },
    //     ],
    //   },
    //   {
    //     category: "比赛流程",
    //     items: [
    //       {
    //         question: "比赛分为几个阶段？每个阶段的具体时间和安排是怎样的？",
    //         answer:
    //           "比赛分为初赛和决赛。进入决赛后，主办方通过邮件或短信通知选手，并邀请参加决赛赛前训练营。具体时间参考官网中赛程安排。",
    //       },
    //       {
    //         question: "是否需要现场演讲？",
    //         answer:
    //           "不设置现场演讲。但获奖后，主办方将邀请获奖选手线上录制课程分享。",
    //       },
    //     ],
    //   },
    //   {
    //     category: "奖项设置",
    //     items: [
    //       {
    //         question: "比赛设有哪些奖项？每个奖项的获奖人数和奖励是什么？",
    //         answer:
    //           "比赛设置“卓越案例奖”、“优秀案例奖”，获奖总人数在30左右。奖励机制见宣传海报。",
    //       },
    //       {
    //         question: "获奖者是否可以获得UpToDate的使用权限或其他资源？",
    //         answer: "获奖者可以获得UpToDate使用权限。",
    //       },
    //     ],
    //   },
    // ],

    // details: [
    //   {
    //     category: "投稿方式",
    //     items: [
    //       {
    //         question: "投稿是通过官方网站、邮箱还是其他平台？",
    //         answer: "目前仅支持官方网站投稿。",
    //       },
    //       {
    //         question: "投稿时需要提交哪些材料？例如，案例报告、PPT、视频等？",
    //         answer:
    //           "初赛投稿作品可接受PPT或PDF文件。如进入决赛，临床/住培案例需要按照中国临床案例成果数据库标准改写为完整的案例报告，采用Word或PDF文件投稿。",
    //       },
    //       {
    //         question: "投稿材料的格式和大小是否有要求？",
    //         answer: "PPT大小不超过100M。",
    //       },
    //     ],
    //   },
    //   {
    //     category: "案例报告撰写",
    //     items: [
    //       {
    //         question: "案例报告是否有固定模板？字数要求是多少？",
    //         answer: "案例无固定模板，不做字数要求",
    //       },
    //       {
    //         question:
    //           "案例报告需要包含哪些内容？例如，病史、检查、诊断、治疗、随访等？",
    //         answer:
    //           "病史、检查、诊断、治疗、随访及UpToDate的应用。详见评分标准。",
    //       },
    //       {
    //         question: "如何平衡案例报告的完整性和简洁性？",
    //         answer: "两者均占分值。详见评分标准。",
    //       },
    //     ],
    //   },
    //   {
    //     category: "其他问题",
    //     items: [
    //       {
    //         question: "投稿后是否可以修改或撤回？",
    //         answer: "投稿后，选手本人无法修改或撤回。",
    //       },
    //       {
    //         question: "如何查询投稿状态和评审结果？",
    //         answer: "关注赛事官网及UpToDate公众号。",
    //       },
    //       {
    //         question: "比赛组委会的联系方式是什么？",
    //         answer: "health@wolterskluwer.cn",
    //       },
    //     ],
    //   },
    // ],

    // help: [
    //   {
    //     category: "中国临床案例成果数据库收录相关问题",
    //     items: [
    //       {
    //         question: "何种案例能够被中国临床案例成果数据库收纳？",
    //         answer:
    //           "中国临床案例成果数据库收纳临床相关案例，获得“卓越案例奖”的临床案例、住培案例将被中国临床案例成果数据库直接收纳",
    //       },
    //       {
    //         question: "如果投稿至中国临床案例成果数据库，是否允许多位作者？",
    //         answer:
    //           "中国临床案例成果数据库允许投稿案例涉及多位作者，但通讯作者仅限1位。",
    //       },
    //       {
    //         question:
    //           "如果未能获得“卓越案例奖”，我是否依然可以尝试投稿中国临床案例成果数据库？",
    //         answer: "可以，请您按照中国临床案例成果数据库要求自行投稿。",
    //       },
    //     ],
    //   },
    // ],
  };

  const weike = () => {
    window.location.href = "https://www.wolterskluwer.cn";
  };

  const utd = () => {
    window.location.href = "https://www.uptodate.cn/home";
  };

  // 立即试用
  const shiyong = () => {
    window.location.href =
      "https://uptodatechina.secure.force.com/IndividualSubscribers?SourceCode=WeChatMenu";
  };

  const resourcesList = [
    {
      title: "关于威科集团（Wolters Kluwer）",
      description:
        "威科集团（Wolters Kluwer）是全球知名的专业信息服务提供商之一。威科集团提供以信息为驱动力的先进工具和软件解决方案，法律、商业、税务、会计、财务、审计、风险、合规和医疗卫生等领域的专业人士依赖这些工具和软件高效管理各自的业务、向客户提供结果，助其在这个瞬息万变的世界中取得成功。",
      img: resource1,
      buttonText: "访问威科中国官网",
      onClick: weike,
    },
    {
      title: "关于UpToDate临床顾问",
      description:
        "UpToDate是威科医疗旗下以循证医学为基础的优质临床决策支持工具，服务于全球44,900多家医疗机构，为全球医生提供高效的医疗决策支持。UpToDate以即时、权威的内容，帮助医疗机构优化临床决策，提升医疗质量。",
      img: resource2,
      buttonText: "了解UpToDate",
      onClick: utd,
    },
    {
      title: "订阅UpToDate临床顾问",
      description:
        "UpToDate临床顾问为您提供多种试用及订购选项，您可根据实际情况进行选择。便捷的访问方式，让您随时随地都能浏览实用的循证临床诊疗信息。",
      img: resource3,
      buttonText: "立即订阅",
      onClick: shiyong,
    },
    // {
    //   title: "珠江医院冯常森：UpToDate让年轻医生站在“巨人的肩膀上”",
    //   description:
    //     "”2022威科医疗循证医学30年“主题征稿活动“我的循证故事”投稿作品。 ",
    //   img: resource4,
    //   buttonText: "了解更多",
    //   onClick: () => {
    //     console.log("了解更多");
    //   },
    // },
  ];

  const handleViewDetails = () => {

    modal.info({
      title: "提示",
      content: "投稿已截止。",
      okText: "确认",
      onOk: () => {
        // navigate("/login");
      },
    });


    // if (userInfo?.phone && userInfo?.status === "1") {
    //   navigate("/player/personalCases/add");
    //   return;
    // }

    // modal.info({
    //   title: "提示",
    //   content: "请先登录。",
    //   okText: "去登录",
    //   onOk: () => {
    //     navigate("/login");
    //   },
    // });
  };

  useEffect(() => {
    // 创建一个 BroadcastChannel 实例
    const channel = new BroadcastChannel("move_to_section");

    // 监听消息
    channel.addEventListener("message", (event) => {
      const section = event.data;
      const item = navMenuList.find((item) => item.section === section);
      if (item) {
        scrollToSection(item.ref, item.section);
      }
    });

    // 清理函数
    return () => {
      channel.close();
    };
  }, []);

  useEffect(() => {
    setUserInfo(user);
  }, [user]);

  return (
    <div className={styles["header-container"]}>
      {modalContextHolder}
      {/* 主横幅区域 */}
      <div className={styles["banner-section"]}>
        <div className={styles["banner-content"]}>
          <div className={styles["banner-title"]}>
            <img src={xjc} alt="" />
          </div>
          <div className={styles["banner-subtitle"]}>
            第九届UpToDate临床顾问案例大赛
          </div>
          <div
            className={styles["banner-slogan"]}
            style={{ visibility: "hidden" }}
            onClick={() => {
              window.open(
                "/awardResult?year=2025",
                "_self",
              );
            }}
          >
            第八届获奖名单已正式出炉！
          </div>
          <div
            className={styles["banner-date"]}
            style={{ visibility: "hidden" }}
            onClick={() => {
              window.open(
                "https://mp.weixin.qq.com/s/xy5h5LOq0bsYtbL4vhuDqA",
                "_blank",
              );
            }}
          >
            点我查看链接
          </div>
          <ButtonField iconPosition={"right"}>
            <button type="button" onClick={() => handleViewDetails()} >
              开始投稿
              <Iconsvg name="arrow-right"></Iconsvg>
            </button>
          </ButtonField>
        </div>
      </div>

      {/* 导航菜单 */}
      <div className={styles["nav-menu"]}>
        {navMenuList.map((item, index) => {
          return (
            <div
              className={`${styles["nav-item"]} ${
                activeNav === item.section ? styles["active"] : ""
              }`}
              key={index}
              onClick={() => scrollToSection(item.ref, item.section)}
            >
              {item.name}
            </div>
          );
        })}
      </div>

      {/* 本届亮点 */}
      <div className={styles["content-section"]} ref={highlightsRef}>
        <div className={styles["section-subtitle"]}>
         2018年起“UpToDate临床顾问案例大赛”正式启动，旨在促进循证医学在临床工作中的实践与应用，助力提升诊疗质量、赋能医学教育、优化科研选题。
         截至2025年底已收获50余个专科、超过2800份投稿案例，覆盖150家机构，80多场机构赛，大赛权威评审专家共计70余名，10,000+临床参赛者。
         UpToDate临床顾问案例大赛设置五大分组：<span style={{ fontWeight: "bold" }}>临床案例、住培案例、管理案例、教学案例、科研案例</span>。
        </div>
        <div className={styles["section-title"]}>本届亮点</div>
        <div className={styles["feature-container"]}>
          {highlightList.map((item, index) => {
            return (
              <div className={styles["feature-box"]} key={index}>
                <div className={styles["feature-icon-circle"]}>
                  <img src={item.icon} alt={item.title} style={{ width: "90px", height: "90px", objectFit: "contain" }} />
                </div>
                <div className={styles["feature-content"]}>
                  <h3 className={styles["feature-title"]}>{item.title}</h3>
                  {/* 使用无序列表渲染数组内容 */}
                  <ul className={styles["feature-desc"]}>
                    {item.content.map((desc, idx) => (
                      <li key={idx}>{desc}</li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 大赛赛程部分 */}
      <div className={styles["timeline-section"]} ref={timelineRef}>
        <div className={styles["timeline-title"]}>大赛赛程</div>

        <div className={styles["timeline-container"]}>
          {timelineList.map((item, index) => {
            return (
              <div className={styles["timeline-step"]} key={index}>
                <div className={styles["step-icon-wrapper"]}>
                  <img src={item.icon} alt={item.title} style={{ width: "86px", height: "86px", objectFit: "contain" }} />
                </div>
                <div className={styles["step-title"]}>{item.title}</div>
                <div className={styles["step-details"]}>
                  {/* 使用无序列表渲染 list 内容 */}
                  <ul>
                    {item.list.map((listItem, listIndex) => {
                      return (
                        <li 
                          className={styles["detail-item"]} 
                          key={listIndex}
                          dangerouslySetInnerHTML={{ __html: listItem }}
                        />
                      );
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 大赛分类及评分标准部分 */}
      <div className={styles["categories-section"]} ref={categoriesRef}>
        <div className={styles["categories-title"]}>大赛分类及评分标准</div>

        <div className={styles["case-accordion"]}>
          {expandedCaseList.map((item, index) => {
            return (
              <div
                className={styles["case-item"]}
                key={index}
                style={{
                  borderBottom:
                    expandedCaseKey === item.key ? "none" : "2px solid #DADADA",
                }}
              >
                <div
                  className={`${styles["case-header"]} ${
                    expandedCaseKey === item.key ? styles["expanded"] : ""
                  }`}
                  onClick={() => {
                    setExpandedCaseKey(
                      expandedCaseKey === item.key ? null : item.key,
                    );
                  }}
                >
                  <div className={styles["case-title"]}>{item.title}</div>
                  <Iconsvg
                    name={
                      expandedCaseKey === item.key
                        ? "chevron-up"
                        : "chevron-down"
                    }
                    size={24}
                    className={styles["case-icon"]}
                  />
                </div>

                {expandedCaseKey === item.key && (
                  <div className={styles["case-content"]}>
                    <div className="case-content-left">
                      <img src={item.img} alt="" />
                    </div>

                    <div className="case-content-right">
                      <table>
                        <thead>
                          <tr>
                            {item.headList.map((headItem, headIndex) => {
                              return (
                                <th
                                  width={
                                    headIndex === 0
                                      ? "15%"
                                      : headIndex === 1
                                        ? "10%"
                                        : "75%"
                                  }
                                  key={headIndex}
                                  style={{
                                    textAlign:
                                      headIndex === 2 ? "center" : "left",
                                  }}
                                  nowrap="nowrap"
                                >
                                  {headItem}
                                </th>
                              );
                            })}
                          </tr>
                        </thead>

                        <tbody>
                          {item.tableList.map((contentItem, contentIndex) => {
                            return (
                              <tr key={contentIndex}>
                                <td className="weight-cell" nowrap="nowrap">
                                  {contentItem.first}
                                </td>
                                <td>{contentItem.second}</td>
                                <td>
                                  <ul>
                                    {contentItem.list.map(
                                      (content, contentIndex) => {
                                        return (
                                          <li key={contentIndex}>{content}</li>
                                        );
                                      },
                                    )}
                                  </ul>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      

      {/* FAQ部分 */}
      <div className={styles["faq-section"]} ref={faqRef}>
        <div className={styles["faq-title"]}>FAQ常见问题</div>
        <div className={styles["faq-tabs"]}>
          <button
            className={`${styles["faq-tab"]} ${
              activeTab === "basic" ? styles["active"] : ""
            }`}
            onClick={() => setActiveTab("basic")}
          >
            赛程赛制
          </button>
          <button
            className={`${styles["faq-tab"]} ${
              activeTab === "details" ? styles["active"] : ""
            }`}
            onClick={() => setActiveTab("details")}
          >
            投稿
          </button>
          <button
            className={`${styles["faq-tab"]} ${
              activeTab === "help" ? styles["active"] : ""
            }`}
            onClick={() => setActiveTab("help")}
          >
            中国临床案例成果数据库收录相关问题
          </button>
        </div>
        <div className={styles["faq-content"]}>
          {faqData[activeTab].map((item, index) => (
            <div
              key={index}
              className={styles["faq-category"]}
              style={{
                borderBottom:
                  faqDataKey === item.question ? "none" : "2px solid #DADADA",
              }}
            >
              <div
                className={`${styles["faq-header"]} ${
                  faqDataKey === item.question ? styles["expanded"] : ""
                }`}
                onClick={() => {
                  setFaqDataKey(
                    faqDataKey === item.question ? null : item.question,
                  );
                }}
              >
                <div className={styles["faq-question"]}>{`${index + 1}. ${
                  item.question
                }`}</div>
                <Iconsvg
                  name={
                    faqDataKey === item.question ? "chevron-up" : "chevron-down"
                  }
                  size={24}
                  className={styles["faq-icon"]}
                />
              </div>
              {faqDataKey === item.question && (
                <>
                  <div className={styles["faq-answer"]}>{item.answer}</div>
                  {item["table"] && (
                    <div className="case-content-right">
                      <table>
                        <thead>
                          <tr>
                            {item["table"].headList.map(
                              (headItem, headIndex) => {
                                return (
                                  <th
                                    width={headIndex === 0 ? "15%" : "85%"}
                                    key={headIndex}
                                    style={{
                                      textAlign: "left",
                                    }}
                                    nowrap="nowrap"
                                  >
                                    {headItem}
                                  </th>
                                );
                              },
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          {item["table"].tableList.map(
                            (contentItem, contentIndex) => {
                              return (
                                <tr key={contentIndex}>
                                  <td className="weight-cell" nowrap="nowrap">
                                    {contentItem.first}
                                  </td>

                                  <td>
                                    <ul>
                                      {contentItem.list.map(
                                        (content, contentIndex) => {
                                          return (
                                            <li key={contentIndex}>
                                              {content}
                                            </li>
                                          );
                                        },
                                      )}
                                    </ul>
                                  </td>
                                </tr>
                              );
                            },
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* 更多资源部分 */}
      <div className={styles["resources-section"]} ref={pastCasesRef}>
        <div className={styles["resources-title"]}>更多资源</div>
        <div className="card-model">
          {resourcesList.map((item, index) => {
            return (
              <div
                className="card-model-item"
                key={index}
                onClick={(e) => {
                  // 阻止事件冒泡
                  e.stopPropagation();
                  item.onClick();
                }}
              >
                <div className="card-model-item-img">
                  <img src={item.img} alt="" />
                </div>

                <div className="card-model-item-content">
                  <div>
                    <div className="card-model-item-content-title">
                      {item.title}
                    </div>
                    <div className="card-model-item-content-text">
                      {item.description}
                    </div>
                  </div>
                  <ButtonField iconPosition={"right"} mode={"ghost"}>
                    <button type="button" onClick={() => item.onClick()}>
                      {item.buttonText}
                      <Iconsvg name="arrow-right"></Iconsvg>
                    </button>
                  </ButtonField>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Home;
